// extracted by mini-css-extract-plugin
export default {"editComment":"styles_edit-comment__rHQmx","editComment__buttons":"styles_edit-comment__buttons__HJT0I"};